// extracted by mini-css-extract-plugin
export default {"divider":"Divider-module__divider--NcRba","margin":"Divider-module__margin--dO5Mf","vertical":"Divider-module__vertical--mAXLI"};